import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
    namespaced: true,
    state: {
        visible: false,
        text: "Hello snackbar!",
        color: "warning",
    },
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// src/store/views/snackbar/index.js